<div>  
  <app-page>
    <app-page-title
      [title]="'SUBSCRIPTIONS.OVERVIEW.TITLE' | translate"
    ></app-page-title>
    <dx-tabs
      *ngIf="canDisplayManageSubscribers"
      class="subscription-tabs"
      width="100%"
      [selectedIndex]="selectedTab"
      [showNavButtons]="false"
      [dataSource]="tabs"
      (onItemClick)="onTabChange($event)"
    ></dx-tabs>
    @if(selectedTab === SubscriptionTabsModel.MySubscriptions) {
      <app-table
        [data]="mySubscriptions"
        [columns]="mySubscriptionColumns"
        [showSearch]="!tenantSubscriptionIdToShow"
        [searchLabel]="'COMMON.SEARCH' | translate"
        [searchPlacehoder]="'COMMON.SEARCH' | translate"
        [showFilterPanel]="true"
      ></app-table>
    } @else if(
      selectedTab === SubscriptionTabsModel.ManageSubscribers &&
      canDisplayManageSubscribers
    ) {
      <app-table
        [data]="tenantSubscribers"
        [columns]="tenantSubscriberColumns"
        [showSearch]="!tenantSubscriptionIdToShow"
        [searchLabel]="'COMMON.SEARCH' | translate"
        [searchPlacehoder]="'COMMON.SEARCH' | translate"
        [showFilterPanel]="true"
      ></app-table>
    }
  </app-page>
</div>

@if(showRequestSubscriptionModal && currentProviderTenantId) {
  <app-request-subscription-modal 
    [(showModal)]="showRequestSubscriptionModal"
    [providerTenantId]="currentProviderTenantId"
    (onSend)="onRequestSubscription()"
  />
}

@if(showRemoveSubscriberModal && currentConsumerTenantId) {
  <app-remove-subscriber-modal
    [(showModal)]="showRemoveSubscriberModal"
    [consumerTenantId]="currentConsumerTenantId"
    (onRemove)="onRemoveSubscriber()"
  />
}

@if(showRejectRequestModal && currentSubscriptionId) {
  <app-reject-request-modal
    [(showModal)]="showRejectRequestModal"
    [currentSubscriptionId]="currentSubscriptionId"
    (onReject)="onRejectRequest()"
  />
}

@if(
  showSubscriptionSettingsModal && 
  currentSubscriptionId && 
  currentSubscriptionTitle
) {
  <app-subscription-settings-modal
    [(showModal)]="showSubscriptionSettingsModal"
    [subscriptionId]="currentSubscriptionId"
    [title]="currentSubscriptionTitle"
    (onSave)="onSaveSubscriptionSettings()"
  />
}

@if(showDisconnectSubscriptionModal && currentProviderTenantId) {
  <app-disconnect-subscription-modal
    [(showModal)]="showDisconnectSubscriptionModal"
    [providerTenantId]="currentProviderTenantId"
    (onDisconnect)="onDisconnectSubscription()"
  />
}